import React, {useEffect} from 'react';
import {FormattedMessage} from 'react-intl';

import {publish} from '@stubhub/pubsub-utils';

import {TICKET_EVENTS} from '../../../../../../tracking/track-enum';

const NoFullfillmentInfo = () => {
  useEffect(() => {
    publish(TICKET_EVENTS.FULLFILMENT_ERROR);
  }, []);

  return (
    <div className="RoyalBuildYourOrder__deliveryContainer">
      <div className="RoyalBuildYourOrder__deliveryContainer__content">
        <FormattedMessage
          id="byo.fullfillment.notFound"
          defaultMessage="Fulfillment information is not available at this time"
        />
      </div>
    </div>
  );
};

export default NoFullfillmentInfo;
